export enum ChartServiceRoutes {
  ORGANIZATION = 'ndp_organizations',
  REGION = 'ndp_region',
  WORLD = 'ndp_world'
}
